<template>
    <div>
        <editor
            v-if="editing"
            :value="bookmarks"
            :live="true"
            style="height: 400px;"
            @input="bookmarks = $event"
        />
        <div
            v-else
            v-html="office_bookmarks"
            v-linkified
            style="height: 100%; overflow: scroll;"
        ></div>
        <div v-if="is_db_admin_active" class="uk-margin-top uk-text-center">
            <base-button
                v-if="!editing"
                @click.prevent="edit"
            >
                Edit
            </base-button>
            <base-button
                v-if="!!editing"
                @click.prevent="editing = false"
            >
                Cancel
            </base-button>
            <base-button
                v-if="!!editing"
                @click.prevent="save"
            >
                Save
            </base-button>
        </div>
    </div>
</template>

<script type="text/javascript">
import dashboard_card from "./dashboard_card"
import profile_utilities from "../../mixins/ProfileUtilities"
import handles_saving from "../../mixins/HandlesSaving"

import Editor from "../../ui/Editor"
import BaseButton from "../../ui/BaseButton"

import linkify from "vue-linkify"

// window.nibnut.vue.application_settings.office_bookmarks
export default {
    mixins: [dashboard_card, profile_utilities, handles_saving],
    components: {
        Editor,
        BaseButton
    },
    directives: {
        linkified: linkify
    },
    methods: {
        edit () {
            this.bookmarks = this.office_bookmarks
            this.editing = true
        },
        save () {
            this.save_field(this.bookmarks, "office_bookmarks").then(() => {
                window.nibnut.vue.application_settings.office_bookmarks = this.bookmarks
                this.editing = false
            })
        }
    },
    computed: {
        office_bookmarks () {
            return window.nibnut.vue.application_settings.office_bookmarks
        }
    },
    data () {
        return {
            entity: "setting",
            record_id: 1,
            editing: false,
            bookmarks: ""
        }
    }
}
</script>
